"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  Day: 'd',
  DeleteFailed: 'Notification failed to delete',
  Earlier: 'Earlier',
  Hour: 'h',
  Minute: 'm',
  New: 'New',
  NoNewNotifications: 'No new notifications',
  NotificationDeleted: 'Notification deleted',
  Notifications: 'Notifications',
  Now: 'now',
  Undo: 'Undo',
  Week: 'w'
};
const translationsNamespace = exports.translationsNamespace = 'notificationmenu';
